import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function KeyLimePie() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Key Lime Pie
          </h1>
          <span className="season-badge season-summer" style={{ marginBottom: 24 }}>☀️ Best in Summer</span>
          <ImageWithFallback
            src="/keylimepie.jpg"
            alt="Key Lime Pie"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginTop: 16, marginBottom: 12 }}>
              For the Crust:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>1 1/2 cups graham cracker crumbs (about 10 crackers)</li>
              <li>1/3 cup granulated sugar</li>
              <li>6 tbsp unsalted butter, melted</li>
            </ul>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              For the Filling:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>4 large egg yolks</li>
              <li>2 cans (14 oz each) sweetened condensed milk</li>
              <li>3/4 cup fresh key lime juice (or regular lime juice)</li>
              <li>2 tsp key lime zest (or regular lime zest)</li>
            </ul>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              For the Topping:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>1 cup heavy whipping cream</li>
              <li>2 tbsp powdered sugar</li>
              <li>1/2 tsp vanilla extract</li>
              <li>Lime slices for garnish (optional)</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Preheat oven:</strong> Preheat your oven to 350°F (175°C).
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Make the crust:</strong> In a bowl, combine graham cracker crumbs, sugar, and melted butter. Mix until it resembles wet sand.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Press crust:</strong> Press the mixture firmly into the bottom and up the sides of a 9-inch pie pan. Bake for 10 minutes, then remove and let cool slightly.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare filling:</strong> In a large bowl, whisk together egg yolks and lime zest until smooth and tinted light green.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add condensed milk:</strong> Add sweetened condensed milk and whisk until well combined.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add lime juice:</strong> Gradually add lime juice while whisking continuously. The mixture will thicken slightly.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Pour and bake:</strong> Pour the filling into the pre-baked crust. Bake for 15-17 minutes until the filling is set but still slightly jiggly in the center.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Cool completely:</strong> Remove from oven and let cool to room temperature. Then refrigerate for at least 3 hours or overnight.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Make whipped cream:</strong> Before serving, beat heavy cream with powdered sugar and vanilla extract until stiff peaks form.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Serve:</strong> Top the chilled pie with whipped cream and garnish with lime slices. Slice and serve cold.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Use fresh lime juice for the best flavor - bottled juice is too acidic</li>
                <li>Key limes are smaller and more tart than regular limes, but either works</li>
                <li>Don't overbake - the center should still have a slight jiggle</li>
                <li>Pie needs at least 3 hours to chill and set properly</li>
                <li>Store covered in refrigerator for up to 3 days</li>
                <li>For extra garnish, add lime zest on top of whipped cream</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Lime juice is a good source of vitamin C, which supports immune health.</li>
                <li>Egg yolks provide vitamin D and healthy fats along with the pie's richness.</li>
                <li>The tart lime filling balances the sweetness, meaning less added sugar is needed overall.</li>
                <li>A small slice pairs well with fresh fruit for a lighter way to enjoy dessert.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default KeyLimePie;